import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { ChevronUp } from "lucide-react";
import { cn } from "@/lib/utils";

const SCROLL_THRESHOLD_PX = 400;

type ScrollToTopFabProps = {
  className?: string;
};

/**
 * Fixed button to jump to top of the page. Visibility follows scroll.
 */
export function ScrollToTopFab({ className }: ScrollToTopFabProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > SCROLL_THRESHOLD_PX);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <Button
      type="button"
      size="icon"
      variant="secondary"
      className={cn(
        "fixed z-50 shadow-md rounded-full h-11 w-11 print:hidden",
        "bottom-6 right-6 md:bottom-8 md:right-8",
        "opacity-90 hover:opacity-100 transition-opacity",
        className
      )}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Scroll to top"
    >
      <ChevronUp className="h-5 w-5" />
    </Button>
  );
}
